import { render } from "./RfqItemsIndex.vue?vue&type=template&id=d2fd82a8"
import script from "./RfqItemsIndex.vue?vue&type=script&lang=js"
export * from "./RfqItemsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__